export function showLogoutConfirmation(message, onConfirm) {
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = 0;
    overlay.style.left = 0;
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.4)';
    overlay.style.display = 'flex';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '1000';
  
    const popupBox = document.createElement('div');
    popupBox.style.backgroundColor = '#FFF';
    popupBox.style.padding = '24px';
    popupBox.style.borderRadius = '12px';
    popupBox.style.boxShadow = '0px 10px 25px rgba(0, 0, 0, 0.1)';
    popupBox.style.maxWidth = '400px';
    popupBox.style.width = '90%';
    popupBox.style.textAlign = 'center';
    popupBox.style.animation = 'fadeIn 0.3s ease';
  
    const messageEl = document.createElement('p');
    messageEl.textContent = message;
    messageEl.style.marginBottom = '20px';
    messageEl.style.fontSize = '16px';
    messageEl.style.color = '#333';
  
    const buttonContainer = document.createElement('div');
    buttonContainer.style.display = 'flex';
    buttonContainer.style.justifyContent = 'center';
    buttonContainer.style.gap = '12px';
  
    const okButton = document.createElement('button');
    okButton.textContent = 'OK';
    okButton.style.padding = '8px 20px';
    okButton.style.border = 'none';
    okButton.style.borderRadius = '6px';
    okButton.style.backgroundColor = '#f44336';
    okButton.style.color = '#fff';
    okButton.style.cursor = 'pointer';
  
    const cancelButton = document.createElement('button');
    cancelButton.textContent = 'Cancel';
    cancelButton.style.padding = '8px 20px';
    cancelButton.style.border = '1px solid #ccc';
    cancelButton.style.borderRadius = '6px';
    cancelButton.style.backgroundColor = '#fff';
    cancelButton.style.color = '#333';
    cancelButton.style.cursor = 'pointer';
  
    okButton.onclick = () => {
      document.body.removeChild(overlay);
      onConfirm(); // call the logout function
    };
  
    cancelButton.onclick = () => {
      document.body.removeChild(overlay);
    };
  
    buttonContainer.appendChild(okButton);
    buttonContainer.appendChild(cancelButton);
    popupBox.appendChild(messageEl);
    popupBox.appendChild(buttonContainer);
    overlay.appendChild(popupBox);
    document.body.appendChild(overlay);
  }
  